import { useRef } from 'react';
import { fileDownloader } from '@helpers/utils';

export const useDownload = () => {
    const controllerRef = useRef(null);

    const startDownload = async (url, fileName) => {
        controllerRef.current = new AbortController();

        try {
            await fileDownloader({
                url,
                fileName,
                signal: controllerRef.current.signal,
            });
        } catch (err) {
            if (err.name === 'CanceledError' || err.name === 'AbortError') {
            }
        }
    };

    const cancelDownload = () => {
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
    };

    return { startDownload, cancelDownload };
};
